import { CSSProperties } from 'react';
import { predicateNumber } from 'utilities/isType.js';

export const getN = (val: number | string): string | undefined => {
  if (predicateNumber(val)) {
    if (Number.isInteger(val)) {
      return val.toFixed(0);
    }
    return val.toFixed(1).slice(1);
  }
  if (val === '') {
    return undefined;
  }
  return val.toString();
};

/** Add borders to legend bars */
export const geLegendBarStyling = (index: number, totalIndexes: number): CSSProperties => {
  if (index === 0) {
    return { borderBottomLeftRadius: '4px', borderTopLeftRadius: '4px' };
  }
  if (index === totalIndexes - 1) {
    return { borderBottomRightRadius: '4px', borderTopRightRadius: '4px' };
  }
  return {};
};
